import { useEffect } from 'react';

/**
 * Hook to detect when Material Icons font has loaded and show icons only then.
 * This prevents showing text labels instead of icons on slow network connections.
 *
 * Usage: Simply call this hook in your root component and it will handle the font loading detection.
 * The CSS in SharedGlobalStyle handles hiding/showing the icons based on the 'fonts-loaded' class.
 */
const useMaterialIconsFontLoading = (): void => {
  useEffect(() => {
    if (document.fonts) {
      Promise.all([document.fonts.load('1em "Material Symbols Outlined"')]).then(() => {
        document.documentElement.classList.add('fonts-loaded');
      });
    }
  }, []);
};

export default useMaterialIconsFontLoading;
